import React, { useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import Paginate from "../components/Paginate";
import {
  listPackingMaterials,
  deletePackingMaterial,
  createPackingMaterial,
} from "../actions/packingMaterialActions";
import { PACKING_MATERIAL_CREATE_RESET } from "../constants/packingMaterialConstants";
import { calculatePrice } from "../utils/calculatePrice";

const PackingMaterialListScreen = ({ history, match }) => {
  const pageNumber = match.params.pageNumber || 1;

  const dispatch = useDispatch();

  const packingMaterialList = useSelector((state) => state.packingMaterialList);
  const { loading, error, packingMaterials, page, pages } = packingMaterialList;

  const packingMaterialDelete = useSelector(
    (state) => state.packingMaterialDelete
  );
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = packingMaterialDelete;

  const packingMaterialCreate = useSelector(
    (state) => state.packingMaterialCreate
  );
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    packingMaterial: createdPackingMaterial,
  } = packingMaterialCreate;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch({ type: PACKING_MATERIAL_CREATE_RESET });

    if (!userInfo || !userInfo.isAdmin) {
      history.push("/login");
    }
    dispatch(listPackingMaterials("", pageNumber));
  }, [
    dispatch,
    history,
    userInfo,
    successDelete,
    createdPackingMaterial,
    pageNumber,
  ]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure")) {
      dispatch(deletePackingMaterial(id));
    }
  };

  const createPackingMaterialHandler = () => {
    history.push("/packing-materials-add");
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>PackingMaterials</h1>
        </Col>
        <Col className="text-right">
          <Button className="my-3" onClick={createPackingMaterialHandler}>
            <i className="fas fa-plus"></i> Create Packing Material
          </Button>
        </Col>
      </Row>
      {loadingDelete && <Loader />}
      {errorDelete && <Message variant="danger">{errorDelete}</Message>}
      {loadingCreate && <Loader />}
      {errorCreate && <Message variant="danger">{errorCreate}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>MATERIAL</th>
                <th>DESCRIPTION</th>
                <th>PRICE</th>
                <th>TAX</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {packingMaterials.map((packingMaterial) => (
                <tr key={packingMaterial._id}>
                  <td>{packingMaterial.cuid}</td>
                  <td>
                    {packingMaterial.material}{" "}
                    {packingMaterial.defaultValue ? (
                      <i className="fas fa-check"></i>
                    ) : (
                      ``
                    )}
                  </td>
                  <td>{packingMaterial.description}</td>
                  <td>{calculatePrice(packingMaterial.price)}</td>
                  <td>{packingMaterial.tax}</td>
                  <td>
                    <LinkContainer
                      to={`/packing-materials/${packingMaterial._id}/edit`}
                    >
                      <Button variant="warning" className="btn-sm">
                        <i className="fas fa-edit"></i>
                      </Button>
                    </LinkContainer>
                    <Button
                      variant="danger"
                      className="btn-sm"
                      onClick={() => deleteHandler(packingMaterial._id)}
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={pages} page={page} isAdmin={true} />
        </>
      )}
    </>
  );
};

export default PackingMaterialListScreen;
